import { css } from '@emotion/react';
import { withPrefix } from 'gatsby-link';

import { breakpoints, colors } from '@/styles';
import { p2r, PrimaryProps, SecondaryProps } from '@/styles/fonts';

const styles = (img, imgMobile, titleFontSize, textFontSize, mobileTitleFontSize, mobileTextFontSize) => css`
  .heroInfo {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: ${p2r(600)};
    background-image: url(${withPrefix(img)});
    background-position: center;
    background-size: cover;

    @media (max-width: ${breakpoints.hugeMobile}px) {
      min-height: ${p2r(571)};
      background-image: url(${withPrefix(imgMobile)});
    }
  }

  .heroInfo-text {
    padding: ${p2r(107)} 0 0 135px;
    color: ${colors.almostBlack};

    &.light {
      color: ${colors.white};
    }

    @media (max-width: ${breakpoints.hugeMobile - 55}px) {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 60% 0 0 17%;
    }

    @media (max-width: ${breakpoints.mobile}px) {
      padding: 45% 5% 0 5%;
    }
  }

  .heroTitle {
    width: 100%;
    max-width: 650px;
    margin: 0 0 ${p2r(20)} 0;
    ${PrimaryProps}
    font-size: ${p2r(titleFontSize)};
    font-style: normal;
    font-weight: bold;
    letter-spacing: -3.1px;

    @media (max-width: ${breakpoints.tablet + 5}px) {
      font-size: ${p2r(54)};
    }

    @media (max-width: ${breakpoints.hugeMobile}px) {
      max-width: 220px;
      font-size: ${p2r(mobileTitleFontSize)};
      letter-spacing: -1.5px;
    }
  }

  .heroText {
    width: 100%;
    max-width: 437px;
    margin: 0;
    ${SecondaryProps}
    font-size: ${p2r(textFontSize)};
    font-style: normal;
    font-weight: normal;
    letter-spacing: 0.4px;

    @media (max-width: ${breakpoints.tablet + 5}px) {
      font-size: ${p2r(18)};
    }

    @media (max-width: ${breakpoints.hugeMobile}px) {
      max-width: 350px;
      font-size: ${p2r(mobileTextFontSize)};
    }
  }

  .heroInfo-sponsor {
    display: flex;
    gap: 24px;
    justify-content: flex-end;
    max-width: 1440px;
    padding: 0 32px;
    margin-bottom: ${p2r(22)};

    @media (max-width: ${breakpoints.hugeMobile - 55}px) {
      margin: 0 31px ${p2r(22)} 0;
    }

    @media (max-width: ${breakpoints.tablet}px) {
      padding: ${p2r(10)} 16px;
    }
  }

  .supportText {
    margin: ${p2r(30)} 0 0 0;
    ${SecondaryProps}
    font-size: ${p2r(15)};
    font-style: normal;
    font-weight: 500;
    line-height: ${p2r(44)};
    color: ${colors.black};
    letter-spacing: 0.75px;

    &.light {
      color: ${colors.white};
    }

    @media (max-width: ${breakpoints.hugeMobile - 55}px) {
      margin: ${p2r(10)} 0 0 0;
      font-size: ${p2r(14)};
    }
  }

  .sponsorImage {
    height: ${p2r(70)};

    @media (max-width: ${breakpoints.hugeMobile - 55}px) {
      display: none;
    }
  }

  .sponsorImageMobile {
    display: none;

    @media (max-width: ${breakpoints.hugeMobile - 55}px) {
      display: block;
    }
  }
`;

export default styles;
